// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3hlIt","colMin":"styles_colMin__2lJF2"};